import { Link, useLoaderData } from 'react-router-dom';
import logo from '../icons/logo.svg';
import { ReactComponent as DashboardIcon } from '../icons/global.svg';
import { ReactComponent as LogoutIcon } from '../icons/logout.svg';

// TODO:
// make this responsive.
// for mobile, create a top bar with a hamburger menu that opens the sidebar

export const Sidebar = () => {
  const data = useLoaderData();
  const userType = localStorage.getItem('userType');

  if(!data || !userType)
    return null; // hide sidebar if no data is available
  
  return (
    <div className="flex flex-col justify-between border-e bg-primary text-primary h-full">
      <div className="px-12 py-6">
        <div className='pb-6'>
          <img src={logo} alt="Clicka Logo" className='text-white self-center mx-auto' />
        </div>
        <ul className="mt-6 space-y-1 font-semibold">
          <li>
            {userType === 'publisher' ? (
              <Link to="/publisher" className='flex gap-2 block bg-white rounded-lg px-4 py-2'>
                <DashboardIcon className='size-5' /><span className='leading-none'>ראשי</span>
              </Link>
            ) : (
              <Link to="/client" className='flex gap-2 block bg-white rounded-lg px-4 py-2'>
                <DashboardIcon className='size-5' /><span className='leading-none'>ראשי</span>
              </Link>
            )}
          </li>
        </ul>
      </div>
      <div className="sticky bottom-0 flex p-4">
        <div className="flex grow items-center gap-2 text-white">
          {/*<img
            alt=""
            src="https://images.unsplash.com/photo-1600486913747-55e5470d6f40?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1770&q=80"
            className="size-10 rounded-full object-cover"
          />*/}
          <p className='font-thin'>
            <span className="block text-xs font-thin">ברוכים השבים</span>
            
            {/*<a href="#" className='text-md underline'>{data.name}</a>*/}
            <span className='text-md underline'>{data.name}</span>
          </p>
        </div>
        <Link to="/user/logout" className="block text-white my-auto" title='התנתק'><LogoutIcon /></Link>
      </div>
    </div>
  );
};